import { useState, useEffect } from 'react';
import { throttle as lodashThrottle } from 'es-toolkit/compat';

export const useWindowSize = (options = { throttle: false }) => {
  const { throttle } = options;
  const isClient = typeof window === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient
        ? Math.min(window.screen.availHeight, window.innerHeight)
        : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener(
      'resize',
      throttle ? lodashThrottle(handleResize, 300) : handleResize,
    );
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};
